import styles from '../css/app.pcss';
import FileUploader from './file-uploader';
import { dLayerFunc } from './form-dlayer-push';
import consentmanager from './consentmanager';
import FaqToggle from './faq-toggle';
import AlignContent from './align-content';
import FunnelForm from './funnel-form';
import ShowMoreChildren from './show-more-children';
import { refreshBlitzCsrfToken } from './refresh-blitz-csrf-token';
import lazySizes from 'lazysizes';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import BlockLinks from './block-links';
import Navigation from './navigation';
import LanguageSwitcher from './language-switcher';
import { fillFormUsingQueryString } from './fill-form-using-query-string';
import EmbeddedVideo from './embedded-video';
import ShopifyCart from './shopify-cart';
import PlayVideoOnScroll from './play-video-on-scroll';
import ImageCarousel from './image-carousel';
import VideoPopup from './video-popup';

const importAll = (r) => r.keys().map(r);

const images = importAll(
  import.meta.webpackContext('../img/', {
    recursive: false,
    include: /\.(webp|png|jpe?g|svg)$/,
  }),
);

window.fileUploader = (fileInputId, selectedFilesId, filenameWrapperCssClass) =>
  new FileUploader(fileInputId, selectedFilesId, filenameWrapperCssClass);

window.showMoreChildren = (buttonClass) => new ShowMoreChildren(buttonClass);

window.funnelForm = () => new FunnelForm();

window.addEventListener('load', () => {
  const forms = document.getElementsByTagName('form');
  forms.length > 0 && refreshBlitzCsrfToken(forms);

  const imageCarousels = document.querySelectorAll('.carousel');
  imageCarousels.forEach((el) => new ImageCarousel(el));

  const blockLinks = new BlockLinks('block-link');
  blockLinks.init();

  fillFormUsingQueryString({
    note: 'form-input-message',
    recommender: 'form-input-tippgeberPartnerID',
  });

  new AlignContent();
  new Navigation();
  new PlayVideoOnScroll();
  new LanguageSwitcher();
});

// Accept HMR as per: https://webpack.js.org/api/hot-module-replacement#accept
if (import.meta.webpackHot) {
  import.meta.webpackHot.accept();
}

// TODO: FIX: remove everything below after removing JS from templates
// import AOS from 'aos';

// const main = () => {
//   AOS.init({ offset: 50 });
//   //document.addEventListener('lazyloaded', AOS.refresh);
//   document.querySelectorAll('section.multi-panels img')
//     .forEach((img) =>
//       img.addEventListener('load', () =>
//         AOS.refresh()
//       )
//     );
// }

// main();
